/* eslint-disable */

/*
 * ⚠️ DO NOT EDIT ⚠️
 * This file is automatically generated, run "yarn run codegen"
 */

import { Types } from '@scorenco/core';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetLivePlayerQueryVariables = Types.Exact<{
  livePlayerId: Types.Scalars['Int']['input'];
}>;

export type GetLivePlayerQuery = {
  __typename: 'query_root';
  lives_live_player_by_pk?:
    | {
        __typename: 'lives_live_player';
        name?: string | undefined;
        number?: any | undefined;
        id: number;
        captain?: boolean | undefined;
        player_picture?: string | undefined;
        player?:
          | {
              __typename: 'teams_team_in_season_has_member';
              photo?: string | undefined;
            }
          | undefined;
      }
    | undefined;
};

export const GetLivePlayerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetLivePlayer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'livePlayerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lives_live_player_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'livePlayerId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'captain' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'player_picture' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'player' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'photo' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLivePlayerQuery, GetLivePlayerQueryVariables>;
